import { useFormikContext } from 'formik';
import React from 'react';
import { SelectOption } from '../../../BaseComponents/Select';

interface AutoSelectAppointmentProps {
  isOpen: boolean;
  selectedAppointmentIdForTestResults: string | number | null;
  appointmentsOptions: SelectOption[];
  onSelectAppointment: (option: SelectOption) => void;
}

const AutoSelectAppointment: React.FC<AutoSelectAppointmentProps> = ({
  isOpen,
  selectedAppointmentIdForTestResults,
  appointmentsOptions,
  onSelectAppointment,
}) => {
  const { values } = useFormikContext<any>();

  React.useEffect(() => {
    if (
      isOpen &&
      selectedAppointmentIdForTestResults &&
      !values.appointment.key
    ) {
      const option = appointmentsOptions.find(
        (opt) => opt.key === selectedAppointmentIdForTestResults
      );
      if (option) {
        onSelectAppointment(option);
      }
    }
  }, [
    isOpen,
    selectedAppointmentIdForTestResults,
    values.appointment.key,
    appointmentsOptions,
    onSelectAppointment,
  ]);

  return null;
};

export default AutoSelectAppointment;
